"use client";

import { forwardRef } from "react";

import { ButtonProps, IconButton, Tooltip } from "@mui/material";
import { cn } from "@utils";

export type TooltipIconButtonProps = ButtonProps & {
  tooltip: string;
  side?: "top" | "bottom" | "left" | "right";
};

export const TooltipIconButton = forwardRef<
  HTMLButtonElement,
  TooltipIconButtonProps
>(({ children, tooltip, side = "bottom", className, ...rest }, ref) => {
  return (
    <Tooltip title={tooltip}>
      <span>
        <IconButton
          size="small"
          {...rest}
          className={cn("size-6 cursor-pointer rounded-full p-1", className)}
          ref={ref}
        >
          {children}
        </IconButton>
      </span>
    </Tooltip>
  );
});

TooltipIconButton.displayName = "TooltipIconButton";
